import { render, staticRenderFns } from "./redirectFromSubdomain.vue?vue&type=template&id=1dd69e2c&"
import script from "./redirectFromSubdomain.vue?vue&type=script&lang=js&"
export * from "./redirectFromSubdomain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports